function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="8" height="28" viewBox="0 0 8 28" {...props}><path d="M6 20.554V2.182C6 .976 5.104 0 4 0S2 .977 2 2.182v18.372c-1.19.693-2 1.969-2 3.445 0 2.208 1.792 4 4 4s4-1.792 4-4a3.982 3.982 0 0 0-2-3.445z" /></svg>;
});